import React from "react";

import { LatestWebTrackerReport } from "../../types";

export type TrackerReportTitleProps = {
  report: LatestWebTrackerReport;
};

function TrackerReportTitle({ report }: TrackerReportTitleProps) {
  return (
    <>
      Tracking Tools on <strong>https://{report.domain}/</strong> as of{" "}
      {report.startedAt.getUTCMonth() + 1}/{report.startedAt.getUTCDate()}
    </>
  );
}

export default TrackerReportTitle;
